import GridViewIcon from '@mui/icons-material/GridView';
import PaymentsIcon from '@mui/icons-material/Payments';
import PeopleIcon from '@mui/icons-material/People';
import RepeatIcon from '@mui/icons-material/Repeat';
import { VerticalNavItemsType } from '@webbyx/mui';
import Trans from 'next-translate/Trans';

export const useNavigationMenuItems = (): VerticalNavItemsType[] => {
  return [
    {
      key: 'dashboard',
      title: <Trans i18nKey="web:drawer.dashboard" />,
      icon: <GridViewIcon />,
      path: '/dashboard',
    },
    {
      key: 'payments',
      title: <Trans i18nKey="web:drawer.payments" />,
      icon: <PaymentsIcon />,
      path: '/payments',
      includes: [
        '/payments/[id]',
        '/payments/[id]/make',
        '/payments/new',
        '/payments/new/[id]',
      ],
    },
    {
      key: 'recurring',
      title: <Trans i18nKey="web:drawer.recurring" />,
      icon: <RepeatIcon />,
      path: '/recurring',
    },
    {
      key: 'collect',
      title: <Trans i18nKey="web:drawer.collect" />,
      icon: <PaymentsIcon />,
      path: '/collect-payment',
      includes: [
        '/collect-payment/[id]',
        '/collect-payment/new',
      ],
    },
    {

      key: 'customer',
      title: <Trans i18nKey="web:drawer.customer" />,
      icon: <PeopleIcon />,
      path: '/customers',
      includes: [
        '/customers/[id]',
        '/customers/new',
      ],
    },
    {
      key: 'recipients',
      title: <Trans i18nKey="web:drawer.recipients" />,
      icon: <PeopleIcon />,
      path: '/recipients',
      includes: ['/recipients/new'],
    },
  ];
};
